import React from 'react'
import { connect } from 'react-redux'

function AboutContest(props) {

    return (
        <section className="about_the_contest">
            <h1 data-aos="fade-up">About The Contest</h1>
            <span className="bubble3"></span>
            <div className="about_the_contest_main">
                <div className="left_about_the_contest_main" data-aos="fade-right">
                    {props.lan === "en" ?
                        <p style={{width:"100%",wordWrap:"break-word",lineHeight:"1.8em"}}>
                            "Article contest 2020" held by ကဝိ-Kawi aims at gentle reminding the youth first voters not to be the preys of political hate speech spreading and perceiving the reliable information of electoral issues. This is a good opportunity to achieve the rewards and also, to mitigate the electoral hate speech and misinformation. The articles of the applicants will be examined by 'ကဝိ-Kawi Myanmar Hate Speech Detection Engine' in order to choose the best articles. Thus, as an independent platform which allows the young people's creative writing and strong attitudes on Myanmar political affairs, we are waiting for your genuine articles.
                        </p> :
                        <p style={{width:"100%",wordWrap:"break-word",lineHeight:"1.8em"}}>
                             ကဝိ(KaWi) မှ ပြုလုပ် ကျင်းပသော "၂၀၂၀ ရွေးကောက်ပွဲ ဆိုင်ရာ ဆောင်းပါးပြိုင်ပွဲ" သည် လာမည့် ၂၀၂၀ အထွေထွေ ရွေးကောက်ပွဲတွင်
                             အသက် ၁၈နှစ် ပြည့်ပြီးနှင့် အထက် ပထမဆုံး အကြိမ် စတင် မဲပေးကြမည့် လူငယ် ၅သန်းခန့် အား ရွေးကောက်ပွဲ ဆိုင်ရာ
                             အမုန်းစကား ဖြန့်ဝေသူများ ၏ သားကောင် မဖြစ်စေရန်နှင့် ရွေးကောက်ပွဲ ဆိုင်ရာ သတင်းအချက်အလက်များ မှန်ကန်စွာ သိရှိနိုင်ရေးအတွက်
                             ရည်ရွယ်၍ ကျင်းပပေးခြင်း ဖြစ်ပါသည်။ ဝင်ရောက် ယှဉ်ပြိုင်လာသည့် မြန်မာဆောင်းပါး များအား 'ကဝိ' မြန်မာစာ အမုန်းစကား
                             Detection Engine ဖြင့်လည်း စစ်ဆေးကာ အကောင်းဆုံး ဆောင်းပါးများကို ရွေးချယ်သွားမည် ဖြစ်သောကြောင့် ဆုကြေးအပြင်
                             ရွေးကောက်ပွဲ ဆိုင်ရာ အမုန်းစကားများ၊ သတင်းအမှားများ အား လျော့ချနိုင်မည့် အခွင့်ကောင်းတစ်ခု ဖြစ်ပါသည်။ လူငယ်များ၏
                             ရွေးကောက်ပွဲ အတွေးအမြင်နှင့် တီထွင် ရေးသား ဖန်တီးနိုင်စွမ်း များကို မျှဝေနိုင်မည့် နေရာတစ်ခု အဖြစ် သင့်ရဲ့ ဆောင်းပါးများ ကို
                             စောင့်မျှော် နေပါသည်။
                        </p>
                    }
                    
                </div>
                <img src="images/about_the_contest.svg" alt="About the Contest" className="about_the_contest_svg" data-aos="fade-left" />
            </div>
        </section>
    )
}

const mapStateToProps = state => {
    return {
        lan: state.lan
    }
}

export default connect(mapStateToProps)(AboutContest)

